/********************************************
* Helper functions (not for a specific block)
********************************************/

/**************
* Force dimensions to be 100vh (to get around Chrome/iOS bar)
**************/
function fnUpdatePopupHeight( oElement ) {

	// Element
	oElement				= $( oElement );

	// Get window height
	var iWindowHeight		= $( window ).height();

	// Apply height to navigation pop-up
	oElement.css( 'height', iWindowHeight + 'px' );

}
$( window ).on( 'load', fnUpdatePopupHeight );
$( window ).on( 'resize', fnUpdatePopupHeight );



// END OF DOCUMENT
